export const rolesLabel: any = {
  SUPER_ADMIN: 'Super Admin',
  YARD_COMPANY_ADMIN: 'Yard Company Admin',
  YARD_COMPANY_EMPLOYEE: 'Yard Company Employee',
  YARD_MANAGER: 'Yard Manager',
  YARD_DISPATCHER: 'Yard Dispatcher',
  CLIENT_MANAGER: 'Client Manager',
  CLIENT_DISPATCHER: 'Client Dispatcher',
};

export const signinRolesLabel: any = {
  YardCompanyAdmin: 'YARD_COMPANY_ADMIN',
  YardCompanyEmployee: 'YARD_COMPANY_EMPLOYEE',
  YardManager: 'YARD_MANAGER',
  YardDispatcher: 'YARD_DISPATCHER',
  YardCraneOperator: 'YARD_CRANE_OPERATOR',
  ClientManager: 'CLIENT_MANAGER',
  ClientDispatcher: 'CLIENT_DISPATCHER',
};

export const inventoryItemStatusLabel: any = {
  FOUND: 'Found',
  EXTRA_FOUND: 'Extra Found',
  NOT_FOUND: 'Not Found',
};

export const repairStatusLabel: any = {
  DRAFT: 'Draft',
  PENDING: 'Pending',
  ACTIVE: 'Active',
  REJECTED: 'Rejected',
  COMPLETED: 'Completed',
};

export const ContainerStatusToChipLabels = {
  IN_TRANSIT: 'In Transit',
  GATED_IN: 'Gated In',
  FOR_SALE: 'For Sale',
  AWAITING_PAYMENT: 'Awaiting Payment',
  SOLD_INST: 'Sold Installment',
  SOLD: 'Sold',
  GATED_OUT: 'Gated Out',
  GATE_OUT_REQUESTED: 'Gate Out Requested',
  GATE_OUT_EXPIRED: 'Gate Out Expired',
  NOT_FOUND: 'Not Found',
  HOLD: 'On Hold',
};

export const ContainerConditionToChipLabels = {
  NEW: 'New',
  CW: 'CW',
  IICL: 'IICL',
  WWT: 'WWT',
  AS_IS: 'As Is',
};